import React, { useRef, useState } from "react";
import Filters from "../filters/Filters";
import Interactivities from "../interactivities/Interactivities";
import "mapbox-gl/dist/mapbox-gl.css";
import Map from "../map/Map";
import { useEffect } from "react";
// import useRasterImages from "./sideEffects/useImages";
import { Layer } from "../layers/Layer";
import { Source } from "../..";
// import { SourceSpecification } from "maplibre-gl";
/**
 * The React Component initiliazes the CUMap class within itself
 * and passes the CUMap Object back through a callback function.
 * It let's you create layers and sources by passing props to it.
 * But you can also just use the CUMap object for full control!
 * @param props
 * @returns
 */
export default function MapSDK(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const initMount = useRef(true);
    // const [cuMap, setCuMap] = useState<CUMap>();
    const cuMapRef = useRef(null);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [_sourcesLayersRemount, setSourcesLayersRemount] = useState(0);
    const [, setPiDataLoaded] = useState(false); // PH: Deprecated?
    const [_mapInteriorLoaded, setMapInteriorLoaded] = useState(false);
    const [badOsmIds, setBadOsmIds] = useState([]);
    // Those are MKs old rasterImages. Doesn't work anymore, so comment it out!
    // const [images] = useRasterImages(props, cuMapRef.current);
    // /* This should not be necessary, but it is: */
    // const imagesFiltered = images.filter((image: any) => {
    //   return image.level === props.map.level || image.level === -999;
    // });
    const [myImages, setMyImages] = useState([]);
    const handleInteriorLoaded = (value) => {
        setMapInteriorLoaded(value);
        if (props.map.onInteriorLoaded)
            props.map.onInteriorLoaded(value);
    };
    const handleSourcesLayersRemount = () => {
        var _a;
        if (initMount.current ||
            !((_a = props.map.init) === null || _a === void 0 ? void 0 : _a.style) ||
            !mapLoaded ||
            !cuMapRef.current)
            return;
        cuMapRef.current.once("styledata", () => {
            setSourcesLayersRemount((prevState) => 1 + prevState);
        });
        cuMapRef.current.setStyle(props.map.init.style);
    };
    useEffect(handleSourcesLayersRemount, [(_a = props.map.init) === null || _a === void 0 ? void 0 : _a.style]);
    useEffect(() => {
        initMount.current = false;
    }, []);
    useEffect(() => {
        var _a;
        const imagesFiltered = (_a = props.product.rasterImages) === null || _a === void 0 ? void 0 : _a.filter((image) => {
            return image.level === props.map.level || image.level == null;
        });
        const imagesFilteredMapped = imagesFiltered === null || imagesFiltered === void 0 ? void 0 : imagesFiltered.map((element) => {
            let myBeforeId = null;
            // console.log("Currently looking at ", element.id);
            if (element.wantedBeforeId != null) {
                if (Object.keys(cuMapRef.current.style._layers).includes(element.wantedBeforeId)) {
                    myBeforeId = element.wantedBeforeId;
                }
                else {
                    myBeforeId = "cu_rooms_geojson";
                }
            }
            // console.log("My Final beforeId is", myBeforeId);
            return {
                ...element,
                layout: {
                    visibility: element.visible
                        ? "visible"
                        : "none",
                },
                beforeId: myBeforeId,
            };
        });
        setMyImages(imagesFilteredMapped);
    }, [props.product.rasterImages]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Map, { cuMapRef: cuMapRef, onLoad: props.map.onLoad, mapboxOptions: props.map.init, mapLoaded: mapLoaded, setMapLoaded: setMapLoaded, setPiDataLoaded: setPiDataLoaded, cuData: props.product, onMapInteriorLoaded: handleInteriorLoaded, setBadOsmIds: setBadOsmIds, setLevelState: props.map.setLevel, regExRoomLabel: (_b = props.map.visible) === null || _b === void 0 ? void 0 : _b.roomLabelsRegularExpression }),
        mapLoaded && cuMapRef.current && (React.createElement(React.Fragment, null,
            React.createElement(Filters, { cuMap: cuMapRef.current, level: props.map.level, buildings: (_c = props.map.visible) === null || _c === void 0 ? void 0 : _c.buildings, buildingLabels: (_d = props.map.visible) === null || _d === void 0 ? void 0 : _d.buildingLabels, buildingMarker: (_e = props.map.visible) === null || _e === void 0 ? void 0 : _e.buildingMarker, roomLabels: (_f = props.map.visible) === null || _f === void 0 ? void 0 : _f.roomLabels, minZoomRoomLabels: (_g = props.map.visible) === null || _g === void 0 ? void 0 : _g.minZoomRoomLabels, hideOsmBuildings: (_h = props.map.visible) === null || _h === void 0 ? void 0 : _h.hideBadOsmBuildings, badOsmIds: badOsmIds }),
            React.createElement(Interactivities, { cuMap: cuMapRef.current, extrusion: !!props.map["extrusion"], camera: props.map.camera }),
            props.sourceRender(cuMapRef.current), myImages === null || myImages === void 0 ? void 0 :
            myImages.map((image) => {
                return (React.createElement(Source, { map: cuMapRef.current, id: "cu_custom_image_source_" + image.id, sourceData: {
                        // coordinates: image.coords,
                        coordinates: [
                            image.coords[0],
                            image.coords[3],
                            image.coords[2],
                            image.coords[1],
                        ],
                        type: "image",
                        url: image.imageUrl,
                    }, key: image.id, layerRender: (map, id) => (React.createElement(Layer, { map: map, source: id, id: "cu_custom_image_layer_" + image.id, layout: image.layout, type: "raster", 
                        // level={props.map.level}
                        level: image.level, paint: { "raster-opacity": image.opacity }, 
                        // @ts-ignore
                        //visible={image.visible}
                        //@ts-ignore
                        // beforeId={image.beforeId}
                        beforeId: image.beforeId, rasterLevel: image.level })) }));
            })))));
}
